/** Matomo event-name for at skelne tekniker-login vs ServicePro-login. */
export type TeknikerLoginMatomoChannel = "Tekniker-login" | "ServicePro-login";

const SERVICEPRO_LOGIN_ROUTE_SEGMENT = "servicepro-login";

/**
 * ServicePro sætter `teknikerLoginRoute: "/servicepro-login"` i APP_SHELL_LAYOUT_OPTIONS.
 * eForsyning tekniker-login har ikke den route → "Tekniker-login".
 */
export function resolveTeknikerLoginMatomoChannel(teknikerLoginRoute?: string | null): TeknikerLoginMatomoChannel {
    const configured = (teknikerLoginRoute || "").replace(/^\/+|\/+$/g, "");
    return configured === SERVICEPRO_LOGIN_ROUTE_SEGMENT ? "ServicePro-login" : "Tekniker-login";
}
